import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './ui/SectionTag';
import { PlaceholderMockup } from './ui/PlaceholderMockup';
import type { TomoContent } from '../types/content';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
interface TomoItemProps {
  tomo: TomoContent;
  reverse: boolean;
}
export function TomoItem({
  tomo,
  reverse
}: TomoItemProps) {
  const isFeatured = Boolean(tomo.featuredBlock);
  return <div className={`flex flex-col gap-10 md:gap-14 ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center border-t border-mp-border pt-16 first:border-t-0 first:pt-0 md:pt-20`} data-id="element-314" data-mp="37d2zt8m36ydd">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.5,
      ease: easeOut
    }} className="w-full md:w-[44%]" data-id="element-315" data-mp="3bd3f0vh0fdlh">
        <PlaceholderMockup label={tomo.imageLabel} aspect="aspect-[4/5]" className={isFeatured ? 'border-mp-lime/40 shadow-glow-lime' : ''} data-id="element-316" data-mp="qm2uue77qbzk" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.5,
      ease: easeOut,
      delay: 0.05
    }} className="w-full md:w-[56%]" data-id="element-317" data-mp="jfby4encj4ov">
        <SectionTag tone="lime" data-id="element-318" data-mp="3rxhtuyw1wcfa">{tomo.label}</SectionTag>
        <h3 className="mt-4 font-heading text-2xl uppercase tracking-wide text-mp-white sm:text-3xl" data-id="element-319" data-mp="3ruvmaz95twx2">
          {tomo.title}
        </h3>
        {tomo.subLabel && <p className="mt-1 font-heading text-xs uppercase tracking-[0.2em] text-mp-electric" data-id="element-320" data-mp="5nxdy4hpcxg8">{tomo.subLabel}</p>}

        <h4 className="mt-4 max-w-[560px] font-heading text-xl uppercase leading-snug text-mp-white sm:text-2xl" data-id="element-321" data-mp="aibesmf4vwsa">
          {tomo.headline}
        </h4>

        <div className="mt-4 max-w-[600px] space-y-3 text-sm leading-relaxed text-mp-gray md:text-base" data-id="element-322" data-mp="3e4a1h505bcwj">
          {tomo.copy.map((p, idx) => <p key={idx} data-id="element-323" data-mp="362ja521xmio7" data-mpi={idx}>{p}</p>)}
        </div>

        <ul className="mt-6 grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-324" data-mp="321zddzl9th2l">
          {tomo.features.map(feature => <li key={feature} className="flex items-start gap-2 text-sm text-mp-gray" data-id="element-325" data-mp="3ftnl7qohljdr">
              <span className="mt-1.5 h-1 w-1 flex-shrink-0 rounded-full bg-mp-lime" data-id="element-326" data-mp="3avvvn3bbe9cq" />
              {feature}
            </li>)}
        </ul>

        {tomo.featuredBlock ? <div className="mt-7 rounded-2xl border border-mp-lime/40 bg-mp-lime/5 p-6" data-id="element-327" data-mp="2j57sjlq2ytwf">
            {tomo.featuredBlock.map((line, idx) => <p key={idx} className={`font-heading uppercase leading-tight sm:text-2xl md:text-3xl ${idx === tomo.featuredBlock!.length - 1 ? 'text-mp-lime' : 'text-mp-white'}`} data-id="element-328" data-mp="2x1l1u7kgnozt" data-mpi={idx}>
                {line}
              </p>)}
          </div> : tomo.destacado && <p className="mt-7 max-w-[600px] rounded-xl border border-mp-border bg-mp-card px-5 py-4 text-sm leading-relaxed text-mp-white" data-id="element-329" data-mp="1paxh036rmdj4">
              {tomo.destacado}
            </p>}
      </motion.div>
    </div>;
}